// 文档：https://github.com/js-cookie/js-cookie

import Cookies from 'js-cookie'

const IS_DEV =  process.env.NODE_ENV === 'development'

const host = location.host.split('.')
host.shift()
// 生产环境下：考虑oem的情况 根据地址栏设置domain
const domain =  IS_DEV ? '' : IS_DEV ? '' : host.join('.')

// Cookies默认 Attributes
Cookies.defaults = {
  domain,
}

const TOKEN_KEY = 'auth_sid'

/**
 * 获取用户授权信息
 */
export function getToken() {
  return Cookies.get(TOKEN_KEY)
}

/**
 * 设置用户授权信息
 * @param {String} token sid
 * @param {Number} [expires=1] token有效期，单位：天
 */
export function setToken(token, expires=1) {
  return Cookies.set(TOKEN_KEY, token, { expires })
}

/**
 * 清除用户授权信息
 */
export function removeToken() {
  Cookies.remove(ROLE_KEY)
  return Cookies.remove(TOKEN_KEY)
}


const ROLE_KEY = 'user_roles'

/**
 * 设置用户角色
 * 
 * @param {Any} roles 用户角色
 * @param {Number} [expires=1] token有效期，单位：天
 */
export function setRoles(roles, expires=1) {
  return Cookies.set(ROLE_KEY, roles, { expires })
}

/**
 * 获取用户角色
 */
export function getRoles() {
  return JSON.parse(Cookies.get(ROLE_KEY) || '[]')
}

/**
 * 清除用户角色
 */
export function removeRoles() {
  Cookies.remove(TOKEN_KEY)
  return Cookies.remove(ROLE_KEY)
}
